import { apiUrl } from "utils/urls";

import axios from "axios";

export const listReviewPage = async (params) => {
    const { data } = await axios.get(apiUrl("review") + `/${params.reference_file_uuid}?page=${params.page}`);
    return data;
};
